window.addEventListener('load', () => {
  document.querySelectorAll('product-card').forEach((card) => {
    const checkedRadio = card.querySelector('.card__swatches input[type="radio"]:checked');
    if (!checkedRadio) return;

    const variantId = checkedRadio.dataset.variantId;
    if (!variantId) return;

    const links = card.querySelectorAll('a.js-prod-link, a.card-link');
    links.forEach((link) => {
      const href = link?.getAttribute('href');
      if (!href) return;

      const url = new URL(href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.setAttribute('href', url.pathname + url.search);
    });
  });

  document.querySelectorAll('.slider__item img').forEach((img) => {
    img.classList.add('loaded');
  });

  if (window.location.pathname === '/collections/shelving') {
    document.querySelectorAll('.subcollections-navigation .sub-collection-item > a').forEach((link) => {
      const title = link.querySelector('.sub_col_title__text')?.textContent?.trim().toLowerCase();
      if (title === 'glass shelving') {
        link.setAttribute('href', '/products/clear-tempered-glass-shelf-3-16-thick');
      }
    });
  }
});

/* Dawson Jones - WIP basket product color-to-gallery sync. */
(() => {
  const productHandle = window.location.pathname
    .replace(/\/+$/, '')
    .split('/products/')[1]?.split(/[/?#]/)[0] || '';
  if (!productHandle.includes('gridwall-slatwall-basket')) return;

  const normalize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const isColorSelector = (selector) => {
    const optionName = normalize(selector?.dataset?.option);
    return optionName === 'color' || optionName === 'colour' || optionName.includes('finish');
  };

  const getSelectedColor = (productRoot) => {
    const selector = Array.from(productRoot.querySelectorAll('.option-selector[data-option]'))
      .find(isColorSelector);
    if (!selector) return '';

    const checked = selector.querySelector('input[type="radio"]:checked');
    if (checked) return normalize(checked.value);

    const select = selector.querySelector('select');
    return normalize(select?.value);
  };

  const findMediaForColor = (gallery, color) => {
    if (!['black', 'white', 'chrome'].includes(color)) return null;

    return Array.from(gallery.querySelectorAll('.media-viewer__item[data-media-id]')).find((item) => {
      const image = item.querySelector('img.product-image, img');
      if (!image) return false;

      const alt = normalize(image.alt);
      const source = String(image.currentSrc || image.src || '').toLowerCase();
      return alt === color
        || alt.startsWith(`${color} `)
        || source.includes(`/${color}_`)
        || source.includes(`${color}_`);
    }) || null;
  };

  const syncBasketGallery = (picker) => {
    const productRoot = picker?.closest('.js-product');
    const gallery = productRoot?.querySelector('media-gallery');
    if (!gallery) return;

    const color = getSelectedColor(productRoot);
    const targetMedia = findMediaForColor(gallery, color);
    if (!targetMedia) return;

    const activate = () => {
      if (typeof gallery.customSetActiveMedia === 'function') {
        gallery.setVisibleItems?.();
        gallery.customSetActiveMedia(targetMedia, true);
      }
    };

    if (customElements.get('media-gallery')) activate();
    else customElements.whenDefined('media-gallery').then(activate);
  };

  document.addEventListener('change', (event) => {
    const picker = event.target.closest?.('variant-picker');
    const selector = event.target.closest?.('.option-selector[data-option]');
    if (!picker || !selector || !isColorSelector(selector)) return;
    window.requestAnimationFrame(() => syncBasketGallery(picker));
  });

  document.addEventListener('on:variant:change', (event) => {
    const picker = event.target.matches?.('variant-picker')
      ? event.target
      : event.target.closest?.('variant-picker');
    if (picker) window.requestAnimationFrame(() => syncBasketGallery(picker));
  });

  window.addEventListener('load', () => {
    const picker = document.querySelector('.js-product variant-picker');
    if (picker) syncBasketGallery(picker);
  });
})();

/* Dawson Jones - WIP-only HD Chrome basket media replacements.
   Replace the SOURCE of the exact native Chrome media nodes while keeping
   their Shopify media IDs unchanged. This lets the theme's native product
   card slider and PDP gallery continue to control which slide is active. */
(() => {
  const chromeByMediaId = new Map([
    ['57907044122995', 'https://cdn.shopify.com/s/files/1/0979/2398/9875/files/chrome-12x6x6-gridwall-slatwall-basket.png?v=1787718623'],
    ['57907095699827', 'https://cdn.shopify.com/s/files/1/0979/2398/9875/files/chrome-12x12x4-gridwall-slatwall-basket.png?v=1787718088'],
    ['57907120046451', 'https://cdn.shopify.com/s/files/1/0979/2398/9875/files/chrome-12x12x8-wip-hd.jpg?v=1787688950'],
    ['57907122176371', 'https://cdn.shopify.com/s/files/1/0979/2398/9875/files/chrome-12x12x8x4-slant-wip-hd.jpg?v=1787688964'],
    ['57907126042995', 'https://cdn.shopify.com/s/files/1/0979/2398/9875/files/chrome-24x10x4-gridwall-slatwall-basket.png?v=1787718814'],
    ['57907130663283', 'https://cdn.shopify.com/s/files/1/0979/2398/9875/files/24x12x4-chrome-basket-wip.jpg?v=1787691442']
  ]);

  const numericMediaId = (value) => String(value || '').split('/').pop();

  const replaceImageSource = (image, url) => {
    if (!image || !url || image.dataset.wipChromeHdApplied === url) return;

    const picture = image.closest('picture');
    picture?.querySelectorAll('source').forEach((source) => {
      source.removeAttribute('data-srcset');
      source.srcset = url;
    });

    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
    image.src = url;
    image.srcset = url;
    image.dataset.wipChromeHdApplied = url;
  };

  const applyChromeHd = (root = document) => {
    root.querySelectorAll?.('[data-media-id]').forEach((node) => {
      const url = chromeByMediaId.get(numericMediaId(node.dataset.mediaId));
      if (url) {
        const image = node.matches('img') ? node : node.querySelector('img');
        replaceImageSource(image, url);
      }
    });
  };

  const applyFromNode = (node) => {
    if (!(node instanceof Element)) return;
    const mediaId = numericMediaId(node.dataset?.mediaId);
    if (chromeByMediaId.has(mediaId)) {
      const image = node.matches('img') ? node : node.querySelector('img');
      replaceImageSource(image, chromeByMediaId.get(mediaId));
    }
    applyChromeHd(node);
  };

  applyChromeHd(document);
  document.addEventListener('DOMContentLoaded', () => applyChromeHd(document), { once: true });
  window.addEventListener('load', () => applyChromeHd(document));
  document.addEventListener('on:facet-filters:updated', () => applyChromeHd(document));

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach(applyFromNode);
    });
  });
  document.querySelectorAll('main, quick-add-drawer, cart-drawer').forEach((container) => {
    observer.observe(container, { childList: true, subtree: true });
  });
})();
